
import './Contact.css';
import React, { useState } from 'react';
import { MdEmail, MdPhone, MdLocationOn, MdAccessTime } from 'react-icons/md';
import {
 
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,

} from 'react-icons/fa';


const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log('Form Data:', formData);
  //   alert('Message sent successfully!');
  //   setFormData({ name: '', email: '', company: '', message: '' });
  // };


//   const handleSubmit = async (e) => {
//   e.preventDefault();
//   try {
//     const response = await fetch('/api/contact', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(formData)
//     });
//     if (response.ok) alert('Message sent successfully!');
//     else alert('Something went wrong.');
//   } catch (err) {
//     console.error(err);
//     alert('Error sending message.');
//   }
// };

// const handleSubmit = (e) => {
//   e.preventDefault();
//   const subject = encodeURIComponent("Contact Form Submission");
//   const body = encodeURIComponent(
//     `Name: ${formData.name}\nEmail: ${formData.email}\nCompany: ${formData.company}\nMessage: ${formData.message}`
//   );
//   window.location.href = `mailto:hitentechnologies?subject=${subject}&body=${body}`;
// };
// const handleSubmit = async (e) => {
//   e.preventDefault();

//   try {
//     const response = await fetch('http://localhost:5000/send', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     });

//     const data = await response.json();

//     // if (data.success) {
//     //   alert('Message sent successfully!');
//     //   setFormData({ name: '', email: '', company: '', message: '' });
//     // } 
//     if (data.success) {
//   alert(`Message sent successfully!\nPreview it here: ${data.preview}`);
//   setFormData({ name: '', email: '', company: '', message: '' });
// }

//     else {
//       alert('Failed to send message. Please try again.');
//     }
//   } catch (error) {
//     console.error('Error:', error);
//     alert('Error sending message. Please try again.');
//   }
// };


  return (
    <div className="contact-page">

      {/* CONTACT FORM + INFO */}
      <div className="contact-top">
        {/* Left Column - Contact Info */}
        
        <div className="contact-info">
          <div className="info-item">
             <div className="icon-box">
            <MdEmail size={24} /></div>
            <div>
              <strong>Email Us</strong>
              <p>support@hitentechnologies.com    </p>
              <small>Send us email anytime</small>
            </div>
          </div>
          <div className="info-item">
              <div className="icon-box">
            <MdPhone size={24} /></div>
            <div>
              <strong>Call Us</strong>
              <p>+91 98904 13967</p>
              <small>Mon-Fri from 8am to 5pm</small>
            </div>
          </div>

          <div className="info-item">
            <div className="icon-box">
            <MdLocationOn size={24} /></div>
            <div>
              <strong>Visit Us</strong>
              <p> Flat N0 304, B Wing, Rajveer Galaxy Sr No 3 Samarth Nagar Dighi,
                 Pune, Maharashtra 411015</p>
              
            </div>
          </div>

          <div className="info-item">
            <div className="icon-box">
            <MdAccessTime size={24} /></div>
            <div>
              <strong>Working Hours</strong>
              <p>Mon – Fri: 10AM – 6PM</p>
              <small>We’re here to help!</small>
            </div>
          </div>

          <div className="social-icons-contact">
            <strong>Follow Us</strong>
            <div className="icons">
             { /*<button>🔗</button>
              <button>🐦</button>
              <button>💬</button>*/}
              <a href="https://www.facebook.com/HitenTechnologies/" target="_blank" rel="noopener noreferrer">
                        <FaFacebookF size={20}/>
                      </a>
                      {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                        <FaTwitter size={20}/>
                      </a> */}
                      <a href="https://www.instagram.com/hitentechnologies/" target="_blank" rel="noopener noreferrer">
                        <FaInstagram size={20}/>
                      </a>
                      <a href="https://www.linkedin.com/company/hiten-technologies/" target="_blank" rel="noopener noreferrer">
                        <FaLinkedinIn size={20} />
                      </a>
                      {/* <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                        <FaGithub size={20} /></a> */}
            </div>
          </div>
        </div>

        {/* Right Column - Form */}
        {/* <div className="contact-form">
          <form onSubmit={handleSubmit}>
            <h1>Send us a Message</h1>
            <label>
              Full Name *
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
              />
            </label>

            <label>
              Email Address *
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                placeholder="you@example.com"
              />
            </label>

            <label>
              Company Name
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="Your Company"
              />
            </label>

            <label>
              Message *
              <textarea
                name="message"
                required
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us about your project or requirements..."
              />
            </label>

            <button type="submit" className="submit-btn">
              ✈️ Send Message
            </button>
          </form>
        </div> */}

        <div className="contact-form">
          <form 
            action="https://formsubmit.co/support@hitentechnologies.com" 
            method="POST"
            onSubmit={(e) => {alert("Message sent! We will contact you soon.");
             setFormData({ name: '', email: '', company: '', message: '' });}}
          >
            <h1>Send us a Message</h1>

            <input type="hidden" name="_captcha" value="false" /> {/* disables captcha */}
           {/* <input type="hidden" name="_next" value="https://yourdomain.com/thank-you" />  optional redirect */}

            <label>
              Full Name *
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
              />
            </label>

            <label>
              Email Address *
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                placeholder="you@example.com"
              />
            </label>

            <label>
              Company Name
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="Your Company"
              />
            </label>

            <label>
              Message *
              <textarea
                name="message"
                required
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us about your project or requirements..."
              />
            </label>

            <button type="submit" className="submit-btn">
              ✈️ Send Message
            </button>
          </form>
        </div>
      </div>

      {/* CTA SECTION */}
      <div className="contact-bottom">
        {/* Quick Help */}
        <div className="quick-help">
          <h3>Need Quick Help?</h3>
          <p>Have an urgent project or question? Give us a call and we'll get back to you immediately.</p>
          <a href="tel:+91 98904 13967">
          <button className="call-now-btn">📞 Call Now</button></a>
        </div>
</div>
        {/* Start Your Project */}
        <div className="start-project">
          <h2>Ready to Start Your Project?</h2>
          <p>
            Join 50+ satisfied clients who have transformed their businesses with our innovative IT
            solutions. Let's build something amazing together.
          </p>
          <div className="cta-buttons">
            <a href="tel:+919890413967">
            <button className="start-btn">Start Your Project</button>
            {/* <button className="schedule-btn">Schedule a Call</button> */}
            </a>
          </div>
        </div>
      

    </div>
  );
};



export default Contact;
